import EnrollmentsList from './List'

export default function EnrollmentsListIndex() {
  return <EnrollmentsList />
}
